import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Thread } from "../../timeline-item.types";

@Component({
    selector: 'tm-comment-reactions',
    templateUrl: './comment-reactions.component.html',
    styleUrls: ['./comment-reactions.component.scss'],
    imports: [
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentReactionsComponent {

  @Input()
  threads?: Thread[];

  @Output()
  onToggleThreads = new EventEmitter<void>();

  toggleThreads() {
    this.onToggleThreads.emit();
  }
}